import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const S = {
  Typography: styled(Typography)`
    width: 100%;
    margin-top: 10px;
    color: ${({ theme }) => theme.palette.grey[800]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    text-align: center;
    line-height: 1.53;
  `,
};

const TableFallbackMessage = ({ className, children }) => (
  <S.Typography className={className}>
    {children}
  </S.Typography>
);

TableFallbackMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

TableFallbackMessage.defaultProps = {
  className: undefined,
  children: '',
};

export default TableFallbackMessage;
